import * as React from "react";
import { Input, Button } from "antd";
import axios from "axios";
import { getToken } from "@/utils/localstorage";
import {
  STORAGE_KEY_SelectedShapes,
  getSelectedShapeName,
  getSelectedShape,
  removeSelectedShape,
} from "@/utils/sharePricePerformance/selectedPlaceHolderLocalStorage";
import { logger } from "@/helpers/tslog";
import { fetchDocumentById } from "@/utils/contentmanager/documents";



export default function UpdatePlaceholder() {
  const [value, setValue] = React.useState<string>("");
  const [saved, setSaved] = React.useState<boolean>(false);
  const [savedMessage, setSavedMessage] = React.useState<string>("");

  React.useEffect(() => {
    // Initialize from localStorage
    try {
      const name = getSelectedShapeName();
      if (typeof name === "string") {
        setValue(name);
      }
    } catch {}

    // Update when selection is changed elsewhere
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY_SelectedShapes) {
        try {
          const name = getSelectedShapeName();
          if (typeof name === "string") {
            setValue(name);
          }
        } catch {}
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const handleSave = async () => {
    try {
      const errorChartData = localStorage.getItem("ErrorChartData");
      const errorChartDataObj = errorChartData ? JSON.parse(errorChartData) : null;
      const newPlaceholder = getSelectedShape();
      let oldPlaceholder = errorChartDataObj?.placeholder;
      const documentId = errorChartDataObj?.documentId;
      const documentData = await fetchDocumentById(documentId);
      const documentContent = documentData?.documentContent;
      const llmGlobalState = documentData?.llmGlobalState;
      const documentDataToSave = JSON.parse(documentContent);
      const llmGlobalStateToSave = JSON.parse(llmGlobalState);

      if(!oldPlaceholder) {
        oldPlaceholder = documentDataToSave?.placeholder;
      }

      const geometryMatches = !!(
        oldPlaceholder &&
        newPlaceholder &&
        Number(oldPlaceholder.width) === Number(newPlaceholder.width) &&
        Number(oldPlaceholder.height) === Number(newPlaceholder.height)
      );

      const apiUrl = process.env.API_URL as string;
      const token = await getToken();
     
      
      

      if (geometryMatches && newPlaceholder) {
        logger.info("Geometry matches, updating document content");
        const updatedDocumentContent = {
          ...documentDataToSave,
          placeholder: {
            ...newPlaceholder,
          },
        };
        await axios.post(
          `${apiUrl}/document-edit`,
          {
            documentContent: JSON.stringify(updatedDocumentContent),
            llmGlobalState: JSON.stringify(llmGlobalStateToSave),
          },
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { id: documentId },
          }
        );

        Office.context.ui.messageParent("REFRESH_CHARTS");
        setSavedMessage("New placeholder saved. Now insert the chart.");
        setSaved(true);
        removeSelectedShape();

        return;
      } else {
        logger.info("Geometry does not match, updating document content");
        const updatedDocumentContent = {
          ...documentDataToSave,
          placeholder: {
            ...newPlaceholder,
          },
        };
        localStorage.setItem("alphaEdit", "true");
        localStorage.setItem("ModelDataToBackend", JSON.stringify(updatedDocumentContent));
        localStorage.setItem("modelGlobalState", JSON.stringify(llmGlobalStateToSave));
        localStorage.setItem("documentId", documentId);
        Office.context.ui.messageParent("INSERT_CHART");

        setSavedMessage(
          "Selected placeholder size does not match the previous selection. I will need to regenerate the chart. I will provide updates in the taskpane."
        );
        setSaved(true);
        removeSelectedShape();

        return;
      }
    } catch {}
  };

  return (
    <div style={{ padding: 16, fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {!saved && (
          <>
            <div style={{ marginBottom: 0 }}>
              <div style={{ fontSize: 14, color: "#333", marginBottom: 4 }}>
                <strong>Note:</strong> The placeholder you originally asked me to create the content for seems to have
                changed or been removed. Please confirm which placeholder you want the content added onto.
              </div>
              <div style={{ fontSize: 14, color: "#333", marginBottom: 8 }}>
                <strong>Click on any new placeholder on your slide to select it.</strong>
              </div>
              <div style={{ fontSize: 14, color: "#333", marginBottom: 0 }}>
                <strong>Current Selection:</strong>
              </div>
            </div>
            <Input
              value={value}
              placeholder="=Placeholder name"
              onChange={(e) => setValue(e.target.value)}
              autoFocus
              allowClear
              onPressEnter={handleSave}
              readOnly
            />
            <div style={{ display: "flex", gap: 8 }}>
              <Button type="primary" style={{ background: "#1f7d3d" }} onClick={handleSave}>
                Save
              </Button>
              <Button onClick={() => Office.context.ui.messageParent("CLOSE")}>Cancel</Button>
            </div>
          </>
        )}
        {saved && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              padding: "20px",
              width: "100%",
              maxWidth: "400px",
            }}
          >
            <p style={{ color: "#333", fontSize: 14, lineHeight: 1.5, margin: "0 0 20px 0", fontWeight: "bold" }}>
              {savedMessage || ""}
            </p>
            <Button type="primary" size="large" onClick={() => Office.context.ui.messageParent("CLOSE")}>
              Close
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
